import { render, staticRenderFns } from "./CardSelected.vue?vue&type=template&id=53c5fec9&scoped=true&"
import script from "./CardSelected.vue?vue&type=script&lang=js&"
export * from "./CardSelected.vue?vue&type=script&lang=js&"
import style0 from "./CardSelected.vue?vue&type=style&index=0&id=53c5fec9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c5fec9",
  null
  
)

export default component.exports